import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-sure-dark w-full pt-20 pb-10 border-t border-white/5" data-id="element-41">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-42">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-43">
          {/* Brand & Address */}
          <div className="flex flex-col lg:col-span-2" data-id="element-44">
            <Link to="/" className="text-sure-white text-xl font-bold tracking-wider mb-6 inline-block" data-id="element-45">
              SURE AI
            </Link>
            <p className="text-sure-gray text-sm font-light leading-relaxed max-w-xs mb-6" data-id="element-46">
              Passenger intelligence for public transport. Turning onboard data
              into decision-grade intelligence.
            </p>
            <div className="text-sure-gray text-sm font-light leading-relaxed" data-id="element-47">
              <p className="text-sure-white font-medium mb-2 uppercase tracking-widest text-xs" data-id="element-48">
                London Office
              </p>
              <p data-id="element-49">71-75 Shelton Street</p>
              <p data-id="element-50">Covent Garden, London</p>
              <p data-id="element-51">WC2H 9JQ, United Kingdom</p>
              <p className="mt-4" data-id="element-52">
                <a href="mailto:sales@sure-ai.tech" className="hover:text-sure-accent transition-colors" data-id="element-53">
                  sales@sure-ai.tech
                </a>
              </p>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex flex-col" data-id="element-54">
            <h4 className="text-sure-white text-xs font-bold uppercase tracking-widest mb-6" data-id="element-55">
              Platform
            </h4>
            <ul className="space-y-4" data-id="element-56">
              <li data-id="element-57">
                <Link to="/what-we-do" className="text-sure-gray text-sm hover:text-sure-accent transition-colors duration-300" data-id="element-58">
                  What We Do
                </Link>
              </li>
              <li data-id="element-59">
                <Link to="/platform" className="text-sure-gray text-sm hover:text-sure-accent transition-colors duration-300" data-id="element-60">
                  Platform
                </Link>
              </li>
              <li data-id="element-61">
                <Link to="/use-cases" className="text-sure-gray text-sm hover:text-sure-accent transition-colors duration-300" data-id="element-62">
                  Use Cases
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/why-sure-ai" className="text-sure-gray text-sm hover:text-sure-accent transition-colors duration-300" data-id="element-64">
                  Why SURE AI
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="flex flex-col" data-id="element-65">
            <h4 className="text-sure-white text-xs font-bold uppercase tracking-widest mb-6" data-id="element-66">
              Company
            </h4>
            <ul className="space-y-4" data-id="element-67">
              <li data-id="element-68">
                <Link to="/about" className="text-sure-gray text-sm hover:text-sure-accent transition-colors duration-300" data-id="element-69">
                  About Us
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/contact" className="text-sure-gray text-sm hover:text-sure-accent transition-colors duration-300" data-id="element-71">
                  Contact
                </Link>
              </li>
              <li data-id="element-72">
                <a href="#" className="text-sure-gray text-sm hover:text-sure-accent transition-colors duration-300" data-id="element-73">
                  Careers
                </a>
              </li>
              <li data-id="element-74">
                <a href="#" className="text-sure-gray text-sm hover:text-sure-accent transition-colors duration-300" data-id="element-75">
                  News & Press
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-76">
          <p className="text-sure-gray text-xs font-light" data-id="element-77">
            &copy; {currentYear} SURE AI Ltd. All rights reserved.
          </p>
          <div className="flex items-center space-x-6" data-id="element-78">
            <a href="#" className="text-sure-gray text-xs hover:text-sure-white transition-colors duration-300" data-id="element-79">
              Privacy Policy
            </a>
            <a href="#" className="text-sure-gray text-xs hover:text-sure-white transition-colors duration-300" data-id="element-80">
              Terms of Service
            </a>
            <a href="#" className="text-sure-gray text-xs hover:text-sure-white transition-colors duration-300" data-id="element-81">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}